import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBookingOverlap({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M9.5.75c.966 0 1.75.784 1.75 1.75v2.25h2.25a1.75 1.75 0 011.744 1.606l.006.144v7a1.75 1.75 0 01-1.75 1.75h-7a1.75 1.75 0 01-1.75-1.75v-2.25H2.5A1.75 1.75 0 01.756 9.644L.75 9.5v-7c0-.966.784-1.75 1.75-1.75zm4 5.5h-2.25V9.5a1.75 1.75 0 01-1.606 1.744l-.144.006H6.25v2.25a.25.25 0 00.193.243l.057.007h7a.25.25 0 00.25-.25v-7a.25.25 0 00-.25-.25zm-4-4h-7a.25.25 0 00-.25.25v7c0 .138.112.25.25.25h2.25V6.5a1.75 1.75 0 011.606-1.744L6.5 4.75h3.25V2.5a.25.25 0 00-.193-.243L9.5 2.25zm.25 4H6.5a.25.25 0 00-.25.25v3.25H9.5a.25.25 0 00.243-.193L9.75 9.5V6.25z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBookingOverlap.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBookingOverlap.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBookingOverlap svgRef={ref} {...props} />);
export default ForwardRef;
